import axiosGlobalInstance from './http-instance';
import { encode } from '../utils';

const getZipcode = ({ zipcode }) => {
  const clientId = 1;
  const clientIdentifier = 'c4ca4238a0b923820dcc509a6f75849b';

  const auth = encode({
    value: `${clientId}:${clientIdentifier}`
  });

  return axiosGlobalInstance({
    method: 'GET',
    url: '/localidade.public.php',
    headers: {
      token: `Basic ${auth}`,
      action: 'searchByZipcode',
    },
    params: {
      q: zipcode
    },
  })
}

export default getZipcode;
